webpackJsonp([159252340728242],{

/***/ 426:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/drs.md absPath of file >>> MarkdownRemark","html":"<p>Delaware River Solar</p>","fields":{"slug":"/drs/"},"frontmatter":{"date":"April 10, 2018","title":"DRS","cover":"/img/common.png","meta_title":"Drs","meta_description":"Drs","username":"Drs","tags":["Drs"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/drs.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---drs-5df4db9bc9e9e471a90b.js